import { render, staticRenderFns } from "./TeacherOrder.vue?vue&type=template&id=633945ec&scoped=true&"
import script from "./TeacherOrder.vue?vue&type=script&lang=js&"
export * from "./TeacherOrder.vue?vue&type=script&lang=js&"
import style0 from "./TeacherOrder.vue?vue&type=style&index=0&id=633945ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633945ec",
  null
  
)

component.options.__file = "TeacherOrder.vue"
export default component.exports